import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Button, Grid, List, ListItem, Stack, Typography } from '@mui/material';
import { Button1, Button2, Button3 } from 'components/Button';
import MainCard from 'components/MainCard';
import useMain from 'hooks/useMain';
import { isIOS, isAndroid } from 'react-device-detect';
import { useNavigate } from 'react-router';
import testPic from '../../assets/images/mock-floorplan.jpg';
import InstallationGuide from '../../assets/images/installtion-guide/installation_guide.png';

const InstallTutorail = () => {
  const navigate = useNavigate();
  const { t } = useMain();
  const isNotMobileDevice = !isIOS && !isAndroid;
  return (
    <MainCard>
      <Stack direction="column" spacing={2}>
        <Typography variant="h4">{t('BCMS_SYSTEM')} </Typography>
        <Typography variant="body1">{t('INSTALL_1')} </Typography>
        <Typography variant="body1">{t('INSTALL_DETAIL_1')}</Typography>
        <Typography variant="body1">{t('INSTALL_DETAIL_2')}</Typography>
        <Typography variant="body1">{t('INSTALL_2')}</Typography>
        <Typography variant="body1">{t('INSTALL_REMARK')}</Typography>
        <ul>
          <li>
            <Typography variant="body1">{t('INSTALL_REMARK_1')}</Typography>
          </li>
          <li>
            <Typography variant="body1">{t('INSTALL_REMARK_2')}</Typography>
          </li>
        </ul>
        {/* <List>
          註:
          <ListItem>如本人或任何使用此程式者，經上述情況受到損失，本人須承擔責任。</ListItem>
          <ListItem>電訊公司或會收取數據傳送或瀏覽費用，詳情請向你的電訊公司查詢。</ListItem>
          <ListItem>為確保你能夠使用新功能，兼享安全又流暢的用戶體驗，請經常更新應用程式並於最新版本操作系統的設備上使用。</ListItem>
        </List> */}
        <Grid container rowSpacing={2}>
          <Grid item xs={12}>
            <Button1
              // disabled={!isAndroid}
              onClick={() => {
                //   if (!isNotMobileDevice) {
                //     window.location = process.env.NODE_ENV === 'production' ?? 'https://app.socam.com/app/s/mic.apk';
                //   }
                // if (isAndroid) {
                //   window.location = 'https://app.socam.com/app/s/mic.apk';
                // }
                window.location = 'https://app.socam.com/app/s/mic.apk';
              }}
              text={t('INSTALL_CONFIRM_BTN')}
              sx={{ width: '100%' }}
            />
          </Grid>
          <Grid item xs={12}>
            <Accordion
              sx={{
                border: `1px solid #d8d6de`,
                boxShadow: 'none'
              }}
            >
              <AccordionSummary expandIcon={<ExpandMore />} aria-controls="install-content">
                {t('INSTALL_GUIDELINE')}
              </AccordionSummary>
              <AccordionDetails sx={{ overflowX: 'auto' }}>
                <img src={InstallationGuide} alt="installation-guide"></img>
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Grid item xs={12}>
            <Button2
              onClick={() => navigate('/login')}
              // text={t('BACK_TO_LOGIN')}
              text={'返回登錄'}
              sx={{ width: '100%' }}
            />
          </Grid>
        </Grid>
      </Stack>

      {/* <Grid container direction="column">

      </Grid> */}
    </MainCard>
  );
};

export default InstallTutorail;
